import { CardActions, CircularProgress, colors, Grid, ImageList, ImageListItem, ImageListItemBar } from "@material-ui/core";
import MaterialTable from "material-table";
import React from "react";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { CardActionArea, Button } from '@material-ui/core';
import theminable from '../../../../assets/img/pump.jpeg';



function PumpsList(props) {
  const { item, isPurches, isStock, onClick } = props;
  return (
    <Card sx={{ maxWidth: 345, }} color="primary" style={{
      padding: '1px',
      backgroundColor:item?.itemName==null?colors.green[500]:  item?.itemName.includes("91") ?
      colors.green[500] : item?.itemName.includes("95") ? colors.red[500] :
      item?.itemName.includes("dezal")|| item?.itemName.includes("\u062f\u064a\u0632\u0644")?  "#a8a232":colors.green[500],
      color: '#fff',
      direction: 'rtl',
      minWidth:130              

    }}
      onClick={() => onClick(item)}>
      <CardActionArea style={{padding:5}}>
        {
          <CardMedia
            component="img"
            height="100"
            image={theminable}
            alt="green iguana"
          />

        }

        <CardContent style={{
          paddingTop: '2px',
          minHeight: 55,
        }}>
          <Typography variant="subtitle2" component="div">
            {item.name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
const PumpsCardList = (props) => {

  const {
    Pumps,
    onPumpsClicks,
    isPurches,
    isStock,
  } = props;

  return (
    <div style={{ padding: '8px' }}>
      <Grid container spacing={1}>
        {

          Pumps.map((pumps, i) => (
            <Grid item lg={4} md={4} sm={4} xs={6}>
              <PumpsList
                item={pumps}
                isPurches={isPurches}
                isStock={isStock}
                onClick={() => onPumpsClicks(pumps)}

              />
            </Grid>

          ))
        }
      </Grid>
    </div>
  )
}

export default PumpsCardList;